import { CellProps } from 'react-table';
import { useTranslation } from 'react-i18next';

export default function BenefitTypeTranslations(props: CellProps<{}>) {
  const { t } = useTranslation();

  return <>{t(`menu.${props.value}`)}</>;
}
